import React from 'react';
import classes from './index.module.scss';

const Radio = ({ check = true, register, props, onChangeSingleValue, value }) => {
  
  return (
    <div className={classes.Advanced_Radio}>
      <div className={`${classes.Advanced_Radio_Wrap} radio-wrapper`}>
        <input 
          ref={register} 
          type="radio"
          name={props.name} 
          id={props.choises.f_id}
          value={check ? true : ""}
          disabled={!check}
          checked={value === true || value === "true"}
          onChange={onChangeSingleValue && ((event) => onChangeSingleValue(event, props.name, props.info_type))}
        />
        <label htmlFor={props.choises.f_id}>Yes</label>
      </div>
      <div className={`${classes.Advanced_Radio_Wrap} radio-wrapper`}>
        <input 
          ref={register} 
          type="radio" 
          name={props.name} 
          id={props.choises.s_id} 
          value={check ? false : ""}
          checked={(value === "" || value === false || value === null || value === "false")}
          disabled={!check}
          onChange={onChangeSingleValue && ((event) => onChangeSingleValue(event, props.name, props.info_type))}
        />
        <label htmlFor={props.choises.s_id}>No</label>
      </div>
    </div>
  )
}

export default Radio;